"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseProgressPill = void 0;
var react_1 = __importDefault(require("react"));
var react_circular_progressbar_1 = require("react-circular-progressbar");
var styled_components_1 = __importStar(require("styled-components"));
var polished_1 = require("polished");
var generated_1 = require("../../icons/generated");
var DynamicIcon_1 = require("../DynamicIcon");
var typography_1 = require("../typography");
exports.CourseProgressPill = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: ", " ", ";\n  background-color: ", ";\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.04);\n  border-radius: ", ";\n  margin-left: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  padding: ", " ", ";\n  background-color: ", ";\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.04);\n  border-radius: ", ";\n  margin-left: ", ";\n"])), (0, polished_1.rem)(4), (0, polished_1.rem)(6), function (_a) {
    var theme = _a.theme;
    return theme.colors.background.card;
}, (0, polished_1.rem)(20), (0, polished_1.rem)(6));
var ProgressBarContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  height: ", ";\n  width: ", ";\n"], ["\n  display: flex;\n  height: ", ";\n  width: ", ";\n"])), (0, polished_1.rem)(12), (0, polished_1.rem)(12));
var CourseCompleteIcon = (0, styled_components_1.default)(DynamicIcon_1.DynamicIcon).attrs(function (_a) {
    var theme = _a.theme;
    return ({
        primaryColor: theme.colors.border.success,
        secondaryColor: theme.colors.staticPalette.white,
        width: (0, polished_1.rem)(12),
        height: (0, polished_1.rem)(12),
    });
})(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var CourseProgressText = (0, styled_components_1.default)(typography_1.BodyText).attrs(function (_a) {
    var theme = _a.theme;
    return ({
        sizes: [theme.typography.fontSizes.fontSize12],
        color: theme.colors.text.primary,
    });
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-left: ", ";\n  white-space: nowrap;\n  line-height: 100%;\n"], ["\n  margin-left: ", ";\n  white-space: nowrap;\n  line-height: 100%;\n"])), (0, polished_1.rem)(4));
var CLOCKWISE_ROTATION_TO_OFFSET_ROUNDED_EDGES = 0.02;
var NEGATIVE_PROGRESS_TO_OFFSET_ROUNDED_EDGES = 5;
var CourseProgress = function (_a) {
    var daysCompleted = _a.daysCompleted, totalDays = _a.totalDays, completedText = _a.completedText, getInProgressText = _a.getInProgressText;
    var colors = (0, styled_components_1.useTheme)().colors;
    if (daysCompleted && totalDays) {
        var percentComplete = Math.round((daysCompleted / totalDays) * 100);
        return (react_1.default.createElement(exports.CourseProgressPill, null, percentComplete === 100 ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(CourseCompleteIcon, { Icon: generated_1.CourseCompleteTick }),
            react_1.default.createElement(CourseProgressText, null, completedText))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ProgressBarContainer, null,
                react_1.default.createElement(react_circular_progressbar_1.CircularProgressbar, { value: percentComplete - NEGATIVE_PROGRESS_TO_OFFSET_ROUNDED_EDGES, strokeWidth: 21, styles: (0, react_circular_progressbar_1.buildStyles)({
                        pathColor: colors.border.success,
                        trailColor: colors.background.success,
                        strokeLinecap: 'round',
                        rotation: CLOCKWISE_ROTATION_TO_OFFSET_ROUNDED_EDGES,
                    }) })),
            react_1.default.createElement(CourseProgressText, null, getInProgressText(percentComplete))))));
    }
    return null;
};
exports.default = CourseProgress;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
